import React, { useEffect, useState } from 'react';
import { Button } from './ui/Button';
interface OTPVerificationProps {
  email: string;
  onVerify: (otp: string) => Promise<void>;
  onResend: () => Promise<void>;
  isVerifying: boolean;
}
export function OTPVerification({
  email,
  onVerify,
  onResend,
  isVerifying
}: OTPVerificationProps) {
  const [otp, setOtp] = useState('');
  const [timeLeft, setTimeLeft] = useState(30);
  useEffect(() => {
    if (timeLeft > 0) {
      const timer = setTimeout(() => setTimeLeft(timeLeft - 1), 1000);
      return () => clearTimeout(timer);
    }
  }, [timeLeft]);
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (otp.length === 6) {
      onVerify(otp);
    }
  };
  const handleResend = async () => {
    await onResend();
    setTimeLeft(30);
  };
  return <div className="space-y-6" data-id="element-122">
      <div className="text-center" data-id="element-123">
        <h3 className="text-xl font-retro text-white mb-2" data-id="element-124">
          Verify Your Email
        </h3>
        <p className="text-gray-400 text-sm" data-id="element-125">
          We sent a 6-digit code to{' '}
          <span className="text-primary font-bold" data-id="element-126">{email}</span>
        </p>
      </div>

      <form onSubmit={handleSubmit} className="space-y-4" data-id="element-127">
        <div className="flex justify-center" data-id="element-128">
          <input type="text" maxLength={6} value={otp} onChange={e => {
          const val = e.target.value.replace(/\D/g, '');
          setOtp(val);
        }} className="w-48 text-center text-3xl tracking-[0.5em] font-mono bg-dark-lighter border-2 border-gray-700 rounded-lg py-2 focus:border-primary focus:outline-none text-white" placeholder="000000" autoFocus data-id="element-129" />
        </div>

        <Button type="submit" className="w-full" disabled={otp.length !== 6 || isVerifying} isLoading={isVerifying} data-id="element-130">
          Verify Code
        </Button>
      </form>

      <div className="text-center" data-id="element-131">
        <button onClick={handleResend} disabled={timeLeft > 0} className="text-sm text-gray-500 hover:text-primary disabled:opacity-50 disabled:hover:text-gray-500 transition-colors" data-id="element-132">
          {timeLeft > 0 ? `Resend code in ${timeLeft}s` : 'Resend Code'}
        </button>
      </div>
    </div>;
}